import { useCallback } from 'react';
import cn from 'classnames';

import Space from 'components/generic/Space.component';
import STAFF_GROUP from 'constants/staff/group.const';
import STAFF_NAME from 'constants/staff/name.const';
import { useTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import call from 'utils/functions/call.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './StylistList.module.scss';

const L = logger('StylistList');

const byValidStylist = ({ has_column: hasColumn, serves_as_waitlist: waitlist, status }) => status !== 'deleted' && hasColumn && waitlist !== true;

// FIXME: use .module.scss for the styles and withTheme() for the dark mode
const StylistListItem = ({ onSelect, stylist, name, group, bold }) => {
  const { t } = useTranslation();
  const { user_name: userName, is_self_employed: isSelf } = asObject(stylist);

  const handleClick = useCallback(
    //
    () => {
      const ev = {
        stylist: group === STAFF_GROUP.single ? stylist : name,
        staffName: name,
        staffGroup: group,
        selectedStylist: stylist,
      };

      L.debug('StylistListItem()', 'handleClick()', ev);
      call('StylistListItem.onSelect', onSelect, ev);
    },
    [onSelect, name, stylist, group],
  );

  return (
    <div
      data-bem="StylistListItem"
      tabIndex={0}
      className={cn({
        'select-by': true,
        [CN.fontBold]: bold,
      })}
      role="menuitem"
      onClick={handleClick}
    >
      <Space>{t(name) || t(userName)}</Space>

      {fromAnyToBool(!name && isSelf) && <Space>{`(${t('cashUp.staffPicker.selfEmployed')})`}</Space>}
      {fromAnyToBool(!name && !isSelf) && <Space>{`(${t('cashUp.staffPicker.employed')})`}</Space>}
    </div>
  );
};

// FIXME: use .module.scss for the styles and withTheme() for the dark mode
const StylistList = ({ onSelect, stylists }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="StylistList" role="menu" tabIndex={0} className={CN.component}>
      <div data-bem="StylistList_contents" className="select-box--items">
        <span data-bem="StylistList_label" className="label">
          {t('cashUp.staffPicker.showTakings')}
        </span>

        <StylistListItem name={STAFF_NAME.all} group={STAFF_GROUP.all} onSelect={onSelect} bold />
        <StylistListItem name={STAFF_NAME.salon} group={STAFF_GROUP.salon} onSelect={onSelect} bold />
        <StylistListItem name={STAFF_NAME.employed} group={STAFF_GROUP.employed} onSelect={onSelect} bold />
        <StylistListItem name={STAFF_NAME.self} group={STAFF_GROUP.self} onSelect={onSelect} bold />

        {asArray(stylists)
          .filter(byValidStylist)
          .map((stylist, index) => (
            <StylistListItem key={createNodeKey({ index, tag: asObject(stylist).name })} group={STAFF_GROUP.single} onSelect={onSelect} stylist={stylist} />
          ))}
      </div>
    </div>
  );
};

export default StylistList;
